
import axios from 'axios'
import React, { useEffect, useState } from 'react'

const useGetTlAndEmp = (departmentId) => {
    const [alltloption, setAllTLOption] = useState([])
    const [allempoption, setAllEmpOption] = useState([])

    console.log("allempoption", allempoption)

    useEffect(() => {
        if (!departmentId) return;
        axios.post(process.env.REACT_APP_NEW_BASE_URL + '/getLeadsAndEmployees', {
            department: departmentId
        })
            .then((res) => {
                const leads = res?.data?.leads || [];
                const employees = res?.data?.employees || [];

                const filterTLOption = leads.map((itm) => ({
                    value: itm.empId,
                    label: itm.name
                }));
                setAllTLOption(filterTLOption);

                const filterEmpOption = employees.map((itm) => ({
                    value: itm.empId,
                    label: itm.name
                }));
                setAllEmpOption(filterEmpOption);
            })
            .catch((err) => {
                console.log("Error", err)
            })
    }, [departmentId])

    return { alltloption, allempoption }
}

export default useGetTlAndEmp;
